import { createFileRoute } from '@tanstack/react-router'
import { Brand, ButtonLink, Chip } from '../components/ui'
import { votes } from '../design/tokens'

export const Route = createFileRoute('/welcome')({ component: Welcome })

function Welcome() {
  return (
    <div className="mx-auto grid min-h-dvh w-full max-w-[460px] content-center gap-8 px-5 py-10">
      <header className="grid gap-4">
        <h1 aria-label="Cat Bowl">
          <Brand size={64} />
        </h1>
        <p className="text-[17px] text-muted">A weekly photo contest for you, your friends, and the cats who run your homes.</p>
      </header>
      <ol className="grid gap-3 text-[15px]">
        {[
          ['Three categories a week', 'Loaf. Sunbeam. Judging you.'],
          ['Post your best', 'Photos or short videos, as many as you like.'],
          [`Five ${votes(5)} each`, 'Hand them out on Sunday or Monday. Your own posts are off limits.'],
          ['Rosettes on Tuesday', 'Blue, red and yellow, like a real cat show.'],
        ].map(([t, d]) => (
          <li key={t} className="grid grid-cols-[auto_1fr] gap-x-3">
            <span aria-hidden className="mt-[7px] size-2 rounded-full bg-accent" />
            <span>
              <b className="font-semibold">{t}.</b> <span className="text-muted">{d}</span>
            </span>
          </li>
        ))}
      </ol>
      <div className="grid gap-2.5">
        <ButtonLink to="/signup" variant="primary" block>
          Create an account
        </ButtonLink>
        <ButtonLink to="/login" block>
          Sign in
        </ButtonLink>
      </div>
      <p className="flex flex-wrap items-center gap-2 text-[13.5px] text-muted">
        <Chip>Got an invite link?</Chip> Open it and you'll land in the right league.
      </p>
    </div>
  )
}
